<template>
    <div class="accordion-group">
        <div class="accordion" v-for="(accordion, index) in content">
            <div class="accordion-title collapsed"
                 data-toggle="collapse"
                 :data-target="`#${prefix}-${index}`"
                 :aria-controls="`${prefix}-${index}`">{{ lodash.get(translate, accordion.title) }}
            </div>
            <div class="accordion-content collapse"
                 :id="`${prefix}-${index}`"
                 v-html="lodash.get(translate, accordion.content) "></div>
        </div>
    </div>
</template>

<script>
const data = () => {
    return {
        lodash: _,
        activeIndex: Array,
    }
};

export default {
    data,
    computed: {
        ...mapState(['translate'])
    },
    props: {
        content: {
            type: Array | Object
        },
        prefix: {
            type: String
        }
    },
}
</script>
